import {
  getEmailStages,
  postEmailStage,
  getEmailStagById,
  getJobEvents,
  getJobEventById,
  postJobEvent,
  getOutageSettings,
  putOutageSetting,
} from './services/notifications-api';

export const SET_EMAIL_STAGES = 'notifications/SET_EMAIL_STAGES';
export const SET_JOB_AUTOREMAILS = 'notifications/SET_JOB_AUTOREMAILS';
export const SET_EMAIL_STAGE = 'notifications/SET_EMAIL_STAGE';

export const FETCH_EMAIL_STAGES = 'notifications/FETCH_EMAIL_STAGES';
export const FETCH_EMAIL_STAGE = 'notifications/FETCH_EMAIL_STAGE';
export const POST_EMAIL_STAGE = 'notifications/POST_EMAIL_STAGE';

export const SET_JOB_EVENTS = 'notifications/SET_JOB_EVENTS';
export const SET_JOB_EVENT = 'notifications/SET_JOB_EVENT';

export const FETCH_JOB_EVENTS = 'notifications/FETCH_JOB_EVENTS';
export const FETCH_JOB_EVENT = 'notifications/FETCH_JOB_EVENT';
export const POST_JOB_EVENT = 'notifications/POST_JOB_EVENT';

export const SET_OUTAGE = 'notifications/SET_OUTAGE';
export const FETCH_OUTAGE = 'notifications/FETCH_OUTAGE';
export const PUT_OUTAGE = 'notifications/PUT_OUTAGE';

export const notificationsStore = {
  state: {
    emailStages: null,
    emailStage: null,
    jobEvents: null,
    jobEvent: null,
    autoEmails: null,
    outageSetting: null,
  },
  mutations: {
    [SET_EMAIL_STAGES](state, { emailStages }) {
      state.emailStages = emailStages;
    },
    [SET_EMAIL_STAGE](state, emailStage) {
      state.emailStage = emailStage;
    },
    [SET_JOB_EVENTS](state, { jobEvents }) {
      state.jobEvents = jobEvents;
    },
    [SET_JOB_EVENT](state, jobEvent) {
      state.jobEvent = jobEvent;
    },
    [SET_JOB_AUTOREMAILS](state, { autoEmails }) {
      state.autoEmails = autoEmails;
    },
    [SET_OUTAGE](state, outage) {
      state.outageSetting = outage;
    },
  },
  getters: {
    emailStages: (state) => state.emailStages,
    emailStage: (state) => state.emailStage,
    jobEvent: (state) => state.jobEvent,
    jobEvents: (state) => state.jobEvents,
    autoEmails: (state) => state.autoEmails,
    outage: (state) => state.outageSetting,
  },
  actions: {
    [FETCH_EMAIL_STAGE]: async ({ commit }, payload) => {
      try {
        const { stageId } = payload;
        return await getEmailStagById(stageId)
          .then((resp) => {
            commit(SET_EMAIL_STAGE, resp.data);
          }).catch((error) => {
            commit(SET_EMAIL_STAGE, null);
            console.error(`getnotification_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_EMAIL_STAGE, null);
        console.error(`getnotification_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_EMAIL_STAGES]: async ({ commit }) => {
      try {
        return await getEmailStages()
          .then((resp) => {
            commit(SET_EMAIL_STAGES, { emailStages: resp.data });
          }).catch((error) => {
            commit(SET_EMAIL_STAGES, { emailStages: null });
            console.error(`get-notifications_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_EMAIL_STAGES, { emailStages: null });
        console.error(`getno-tifications_err:${error.Status}`);
        throw error;
      }
    },
    [POST_EMAIL_STAGE]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await postEmailStage(data);
      } catch (error) {
        console.error(`post-notificatins_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_JOB_EVENT]: async ({ commit }, payload) => {
      try {
        const jobId = payload;
        return await getJobEventById(jobId)
          .then((resp) => {
            commit(SET_JOB_EVENT, resp.data);
          }).catch((error) => {
            commit(SET_JOB_EVENT, null);
            console.error(`getnotification_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_JOB_EVENT, null);
        console.error(`getnotification_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_JOB_EVENTS]: async ({ commit }) => {
      try {
        return await getJobEvents()
          .then((resp) => {
            const jobList = [];
            const autoEmailList = [];
            for (let i = 0; i < resp.data.length; i += 1) {
              if (resp.data[i].jobCategroy === 'Job') {
                jobList.push(resp.data[i]);
              } else {
                autoEmailList.push(resp.data[i]);
              }
            }
            commit(SET_JOB_EVENTS, { jobEvents: jobList });
            commit(SET_JOB_AUTOREMAILS, { autoEmails: autoEmailList });
          })
          .catch((error) => {
            commit(SET_JOB_EVENTS, { jobEvents: null });
            commit(SET_JOB_AUTOREMAILS, { autoEmails: null });
            console.error(`get-notifications_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_JOB_EVENTS, { jobEvents: null });
        commit(SET_JOB_AUTOREMAILS, { autoEmails: null });
        console.error(`getno-tifications_err:${error.Status}`);
        throw error;
      }
    },
    [POST_JOB_EVENT]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await postJobEvent(data);
      } catch (error) {
        console.error(`post-notificatins_err:${error.Status}`);
        throw error;
      }
    },
    // eslint-disable-next-line consistent-return
    [FETCH_OUTAGE]: async ({ commit }) => {
      try {
        const resp = await getOutageSettings();
        const outageSettings = resp.data;
        const outage = outageSettings[0];
        // outage.fromDateTime='2022-12-14T24:05:00Z'
        // outage.endDateTime='2022-12-14T24:50:00Z'
        // console.log('FETCH_OUTAGE::outage', outage);
        commit(SET_OUTAGE, outage);
        return outage;
      } catch (err) {
        commit(SET_OUTAGE, null);
        console.error('ERROR:', err);
      }
    },
    [PUT_OUTAGE]: async ({ commit }, payload) => {
      try {
        const { data } = payload;
        // console.log('PUT_OUTAGE::data:', data);
        const resp = await putOutageSetting(data);
        const outageSettings = resp.data;
        commit(SET_OUTAGE, outageSettings);
      } catch (err) {
        console.error('ERROR:', err);
      }
    },
  },
};
